import { render, staticRenderFns } from "./MarketplacePage.vue?vue&type=template&id=6d9750aa&scoped=true"
import script from "./MarketplacePage.vue?vue&type=script&lang=js"
export * from "./MarketplacePage.vue?vue&type=script&lang=js"
import style0 from "./MarketplacePage.vue?vue&type=style&index=0&id=6d9750aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9750aa",
  null
  
)

export default component.exports